import React, { useState, useEffect } from "react";
import {
  Container,
  Paper,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Alert,
  Box,
  Chip,
  Autocomplete,
  Grid,
  InputAdornment,
  ToggleButton,
  ToggleButtonGroup,
  FormControlLabel,
  Switch,
  RadioGroup,
  Radio,
  FormLabel,
} from "@mui/material";
import {
  Add,
  Edit,
  Delete,
  Visibility,
  Search,
  Clear,
} from "@mui/icons-material";
import "bootstrap/dist/css/bootstrap.min.css";
import { FiPackage } from "react-icons/fi";

const QuanLySanPham = () => {
  const CATEGORY_TYPE_LABELS = {
    dongTien: "Đồng Tiến",
    bonPas: "BonPas",
    hoChiMinh: "Hồ Chí Minh",
  };
  const getAllowedCategoryTypes = () => {
    const isHcmAdmin = localStorage.getItem("HCM_ADMIN") === "true";
    const isAdmin = localStorage.getItem("isAdmin") === "true";
    const isBakery = localStorage.getItem("isBakery") === "true";
    if (isHcmAdmin) return ["hoChiMinh"];
    if (isAdmin || isBakery) return ["dongTien", "bonPas", "hoChiMinh"];
    return ["dongTien", "bonPas"];
  };
  const [availableCategoryTypes] = useState(getAllowedCategoryTypes);
  const [categoryType, setCategoryType] = useState(() => {
    const types = getAllowedCategoryTypes();
    return types.includes("dongTien") ? "dongTien" : types[0];
  });
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [stores, setStores] = useState([]);
  const [filteredStores, setFilteredStores] = useState([]);
  const [categories, setCategories] = useState([]);
  const [items, setItems] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [editingProduct, setEditingProduct] = useState(null);
  const [alert, setAlert] = useState({
    show: false,
    message: "",
    type: "success",
  });
  const [searchFilters, setSearchFilters] = useState({
    searchText: "",
    selectedStore: "",
    selectedCategory: "",
    showOnlyActive: false, // New filter for active products only
  });
  const [formData, setFormData] = useState({
    IDCH: "",
    IDCHs: [],
    MaSP: "",
    MaNLSP: "",
    Gia: "",
    GiaGrab: "",
    GiaFoody: "",
    TuNgay: "",
    DenNgay: "",
    Act_SP: 1,
    UuTien: 1,
    selectedCategories: [], // New for bulk
    adjustmentType: "increase", // New for bulk
    adjustmentUnit: "%", // New for bulk
    adjustmentValue: 0, // New for bulk
  });
  const [isBulkMode, setIsBulkMode] = useState(false); // New state for bulk mode

  // Fetch products on component mount
  useEffect(() => {
    fetchProducts();
  }, []);

  useEffect(() => {
    fetchStores();
    fetchCategories();
  }, [categoryType]);

  // Filter products when search criteria or products change
  useEffect(() => {
    filterProducts();
  }, [products, searchFilters, stores, categories, categoryType]);

  // Filter stores when category type changes
  useEffect(() => {
    filterStores();
  }, [stores, categoryType]);

  const fetchProducts = async () => {
    try {
      const response = await fetch(
        "https://doticom.vn:3000/api/cua-hang-san-pham"
      );
      const data = await response.json();
      setProducts(data);
    } catch (error) {
      showAlert("Lỗi khi tải dữ liệu sản phẩm", "error");
    }
  };

  const fetchStores = async () => {
    try {
      const endpoint =
        categoryType === "hoChiMinh"
          ? "https://doticom.vn:3000/stores-hcm"
          : "https://doticom.vn:3000/stores";
      const response = await fetch(endpoint);
      const data = await response.json();
      setStores(data);
    } catch (error) {
      showAlert("Lỗi khi tải danh sách cửa hàng", "error");
    }
  };

  const fetchCategories = async () => {
    try {
      const endpoint =
      categoryType === "bonPas"
        ? "https://doticom.vn:3000/categories-bonpas"
        : categoryType === "hoChiMinh"
        ? "https://doticom.vn:3000/categories-hcm"
        : "https://doticom.vn:3000/categories";
      const response = await fetch(endpoint);
      const data = await response.json();
      setCategories(data);
      setSearchFilters((prev) => ({
        ...prev,
        selectedCategory: "",
      }));
    } catch (error) {
      showAlert("Lỗi khi tải danh sách loại sản phẩm", "error");
    }
  };

  const fetchItems = async (categoryCode) => {
    if (!categoryCode) return;
    try {
      const response = await fetch(
        `https://doticom.vn:3000/items?category=${categoryCode}`
      );
      const data = await response.json();
      setItems(data);
    } catch (error) {
      showAlert("Lỗi khi tải danh sách sản phẩm", "error");
    }
  };

  const fetchItemsForCategories = async (categoryCodes) => {
    const allItems = [];
    for (const code of categoryCodes) {
      try {
        const response = await fetch(
          `https://doticom.vn:3000/items?category=${code}`
        );
        const data = await response.json();
        allItems.push(...data);
      } catch (error) {
        showAlert("Lỗi khi tải danh sách sản phẩm cho loại " + code, "error");
      }
    }
    return allItems;
  };

  const showAlert = (message, type = "success") => {
    setAlert({ show: true, message, type });
    setTimeout(
      () => setAlert({ show: false, message: "", type: "success" }),
      3000
    );
  };

  const handleOpenDialog = (product = null) => {
    if (product) {
      setEditingProduct(product);
      setFormData({
        IDCH: product.IDCH,
        IDCHs: [product.IDCH], // For editing, set single store in array
        MaSP: product.MaSP,
        MaNLSP: product.MaNLSP,
        Gia: product.Gia,
        GiaGrab: product.GiaGrab || "",
        GiaFoody: product.GiaFoody || "",
        TuNgay: product.TuNgay?.split("T")[0] || "",
        DenNgay: product.DenNgay?.split("T")[0] || "",
        Act_SP: product.Act_SP,
        UuTien: product.UuTien,
        selectedCategories: [], // Reset for bulk
        adjustmentType: "increase",
        adjustmentUnit: "%",
        adjustmentValue: 0,
      });
      // Fetch items for the selected category
      if (product.MaNLSP) {
        fetchItems(product.MaNLSP);
      }
    } else {
      setEditingProduct(null);
      setFormData({
        IDCH: "",
        IDCHs: [],
        MaSP: "",
        MaNLSP: "",
        Gia: "",
        GiaGrab: "",
        GiaFoody: "",
        TuNgay: "",
        DenNgay: "",
        Act_SP: 1,
        UuTien: 1,
        selectedCategories: [],
        adjustmentType: "increase",
        adjustmentUnit: "%",
        adjustmentValue: 0,
      });
      setItems([]);
    }
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setEditingProduct(null);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // When category changes, fetch items
    if (name === "MaNLSP") {
      fetchItems(value);
      setFormData((prev) => ({ ...prev, MaSP: "" })); // Reset product selection
    }
  };

  const handleStoreChange = (event) => {
    const value = event.target.value;
    setFormData((prev) => ({
      ...prev,
      IDCHs: typeof value === "string" ? value.split(",") : value,
      IDCH: editingProduct ? prev.IDCH : "", // Keep IDCH for editing mode
    }));
  };

  const handleProductSelect = (event, newValue) => {
    if (newValue) {
      setFormData((prev) => ({
        ...prev,
        MaSP: newValue.MaSP,
        Gia: newValue.DonGia || "",
        GiaGrab: newValue.DonGia || "",
        GiaFoody: newValue.DonGia || "",
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        MaSP: "",
        Gia: "",
        GiaGrab: "",
        GiaFoody: "",
      }));
    }
  };

  const applyPriceAdjustment = (price, adjustmentType, unit, value) => {
    const numPrice = parseFloat(price) || 0;
    const numValue = parseFloat(value) || 0;
    if (unit === "%") {
      const factor =
        adjustmentType === "increase" ? 1 + numValue / 100 : 1 - numValue / 100;
      return numPrice * factor;
    } else {
      return adjustmentType === "increase" ? numPrice + numValue : numPrice - numValue;
    }
  };

  const handleSubmit = async () => {
    try {
      // Validation
      if (!editingProduct && (!formData.IDCHs || formData.IDCHs.length === 0)) {
        showAlert("Vui lòng chọn ít nhất một cửa hàng", "error");
        return;
      }

      if (editingProduct && !formData.IDCH) {
        showAlert("Vui lòng chọn cửa hàng", "error");
        return;
      }

      const url = "https://doticom.vn:3000/api/cua-hang-san-pham";
      const method = editingProduct ? "PUT" : "POST";

      if (isBulkMode && !editingProduct) {
        // Bulk add logic
        if (!formData.selectedCategories || formData.selectedCategories.length === 0) {
          showAlert("Vui lòng chọn ít nhất một loại sản phẩm", "error");
          return;
        }
        const selectedItems = await fetchItemsForCategories(formData.selectedCategories);
        if (selectedItems.length === 0) {
          showAlert("Không có sản phẩm nào trong các loại đã chọn", "error");
          return;
        }
        let successCount = 0;
        for (const item of selectedItems) {
          const adjustedGia = applyPriceAdjustment(item.DonGia, formData.adjustmentType, formData.adjustmentUnit, formData.adjustmentValue);
          const adjustedGiaGrab = applyPriceAdjustment(item.DonGia, formData.adjustmentType, formData.adjustmentUnit, formData.adjustmentValue);
          const adjustedGiaFoody = applyPriceAdjustment(item.DonGia, formData.adjustmentType, formData.adjustmentUnit, formData.adjustmentValue);
          const submitData = {
            IDCHs: formData.IDCHs.map((id) => parseInt(id)),
            MaSP: item.MaSP,
            MaNLSP: item.MaNLSP, // Assuming item has MaNLSP
            Gia: adjustedGia,
            GiaGrab: adjustedGiaGrab,
            GiaFoody: adjustedGiaFoody,
            TuNgay: formData.TuNgay,
            DenNgay: formData.DenNgay,
            Act_SP: parseInt(formData.Act_SP) || 1,
            UuTien: parseInt(formData.UuTien) || 1,
          };
          try {
            const response = await fetch(url, {
              method,
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(submitData),
            });
            if (response.ok) {
              successCount++;
            }
          } catch (error) {
            // Continue to next item
          }
        }
        showAlert(`Thêm thành công ${successCount} sản phẩm`);
        fetchProducts();
        handleCloseDialog();
      } else {
        // Single add/edit logic
        // Prepare data based on mode (add vs edit)
        const submitData = editingProduct
          ? {
              IDCH: parseInt(formData.IDCH),
              MaSP: formData.MaSP,
              MaNLSP: formData.MaNLSP,
              Gia: parseFloat(formData.Gia) || 0,
              GiaGrab: parseFloat(formData.GiaGrab) || 0,
              GiaFoody: parseFloat(formData.GiaFoody) || 0,
              TuNgay: formData.TuNgay,
              DenNgay: formData.DenNgay,
              Act_SP: parseInt(formData.Act_SP) || 1,
              UuTien: parseInt(formData.UuTien) || 1,
            }
          : {
              IDCHs: formData.IDCHs.map((id) => parseInt(id)),
              MaSP: formData.MaSP,
              MaNLSP: formData.MaNLSP,
              Gia: parseFloat(formData.Gia) || 0,
              GiaGrab: parseFloat(formData.GiaGrab) || 0,
              GiaFoody: parseFloat(formData.GiaFoody) || 0,
              TuNgay: formData.TuNgay,
              DenNgay: formData.DenNgay,
              Act_SP: parseInt(formData.Act_SP) || 1,
              UuTien: parseInt(formData.UuTien) || 1,
            };

        // Additional validation for edit mode
        if (editingProduct) {
          if (!submitData.MaSP || !submitData.MaNLSP || !submitData.TuNgay) {
            showAlert("Vui lòng điền đầy đủ thông tin bắt buộc", "error");
            return;
          }
        }

        const response = await fetch(url, {
          method,
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(submitData),
        });

        if (response.ok) {
          const successMessage = editingProduct
            ? "Cập nhật thành công"
            : `Thêm mới thành công cho ${formData.IDCHs.length} cửa hàng`;
          showAlert(successMessage);
          fetchProducts();
          handleCloseDialog();
        } else {
          const errorData = await response.json();
          throw new Error(errorData.message || errorData.error || "Có lỗi xảy ra");
        }
      }
    } catch (error) {
      console.error("Submit error:", error);
      showAlert(error.message || "Có lỗi xảy ra", "error");
    }
  };

  const handleDelete = async (product) => {
    if (window.confirm("Bạn có chắc chắn muốn xóa sản phẩm này?")) {
      try {
        const response = await fetch(
          "https://doticom.vn:3000/api/cua-hang-san-pham",
          {
            method: "DELETE",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              IDCH: product.IDCH,
              MaSP: product.MaSP,
              MaNLSP: product.MaNLSP,
              TuNgay: product.TuNgay,
            }),
          }
        );

        if (response.ok) {
          showAlert("Xóa thành công");
          fetchProducts();
        } else {
          throw new Error("Có lỗi xảy ra");
        }
      } catch (error) {
        showAlert("Có lỗi xảy ra khi xóa", "error");
      }
    }
  };

  const filterProducts = () => {
    let filtered = [...products];
    const allowedStoreIds =
      categoryType === "hoChiMinh"
        ? stores.map((s) => s.IDCH)
        : stores
            .filter((store) =>
              categoryType === "bonPas"
                ? store.LoaiCH === 0 || store.LoaiCH === "0"
                : store.LoaiCH === 2 || store.LoaiCH === "2"
            )
            .map((s) => s.IDCH);

    filtered = filtered.filter((product) =>
      allowedStoreIds.includes(product.IDCH)
    );

    // Filter by search text (product code)
    if (searchFilters.searchText) {
      const searchLower = searchFilters.searchText.toLowerCase();
      filtered = filtered.filter((product) => {
        const productCode = product.MaSP?.toLowerCase() || "";
        return productCode.includes(searchLower);
      });
    }

    // Filter by store
    if (searchFilters.selectedStore) {
      filtered = filtered.filter(
        (product) =>
          product.IDCH.toString() === searchFilters.selectedStore.toString()
      );
    }

    // Filter by category
    if (searchFilters.selectedCategory) {
      filtered = filtered.filter(
        (product) => product.MaNLSP === searchFilters.selectedCategory
      );
    }

    // Filter by active status (TuNgay >= today)
    if (searchFilters.showOnlyActive) {
      const today = new Date();
      today.setHours(0, 0, 0, 0); // Normalize to start of day for date comparison
      filtered = filtered.filter((product) => {
        if (!product.TuNgay) return false;
        const tuNgay = new Date(product.TuNgay);
        return tuNgay >= today;
      });
    }

    setFilteredProducts(filtered);
  };

  const filterStores = () => {
    if (stores.length === 0) return;
    if (categoryType === "hoChiMinh") {
      setFilteredStores(stores);
    } else {
      const filtered = stores.filter((store) => {
        return categoryType === "bonPas"
          ? store.LoaiCH === 0 || store.LoaiCH === "0"
          : store.LoaiCH === 2 || store.LoaiCH === "2";
      });
      setFilteredStores(filtered);
      const isValidStore = filtered.some(
        (store) =>
          store.IDCH.toString() === searchFilters.selectedStore.toString()
      );
      if (searchFilters.selectedStore && !isValidStore) {
        setSearchFilters((prev) => ({
          ...prev,
          selectedStore: "",
        }));
      }
    }
  };

  const handleSearchChange = (field, value) => {
    setSearchFilters((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const clearFilters = () => {
    setSearchFilters({
      searchText: "",
      selectedStore: "",
      selectedCategory: "",
      showOnlyActive: false, // Reset new filter
    });
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    return new Date(dateString).toLocaleDateString("vi-VN");
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat("vi-VN", {
      style: "currency",
      currency: "VND",
    }).format(amount);
  };

  const getStoreName = (storeId) => {
    const store = stores.find((s) => s.IDCH === storeId);
    return store ? store.TenCuaHang : storeId;
  };

  const getCategoryName = (categoryCode) => {
    const category = categories.find((c) => c.MaNLSP === categoryCode);
    return category ? category.TenLoaiSP : categoryCode;
  };

  const getProductName = (productCode) => {
    const item = items.find((i) => i.MaSP === productCode);
    return item ? item.Ten_SP : productCode;
  };

  const handleClearFilters = () => {
    setSearchFilters({
      searchText: "",
      selectedStore: "",
      selectedCategory: "",
      showOnlyActive: false, // Reset new filter
    });
  };

  const handleCategoryTypeChange = (event, newType) => {
    if (newType !== null && availableCategoryTypes.includes(newType)) {
      setCategoryType(newType);
      if (openDialog && !editingProduct) {
        setFormData((prev) => ({
          ...prev,
          IDCH: "",
          IDCHs: [],
          MaNLSP: "",
          MaSP: "",
          Gia: "",
          GiaGrab: "",
          GiaFoody: "",
          selectedCategories: [], // Reset for bulk
        }));
        setItems([]);
      }
    }
  };

  const handleBulkModeChange = (event) => {
    setIsBulkMode(event.target.checked);
    setFormData((prev) => ({
      ...prev,
      selectedCategories: [],
      MaNLSP: "",
      MaSP: "",
      Gia: "",
      GiaGrab: "",
      GiaFoody: "",
    }));
    setItems([]);
  };

  const handleSelectAllCategories = () => {
    setFormData((prev) => ({
      ...prev,
      selectedCategories: prev.selectedCategories.length === categories.length ? [] : categories.map(c => c.MaNLSP),
    }));
  };

  return (
    <div className="admin-layout">
      <div className="admin-main" style={{ marginLeft: 0 }}>
        <header className="admin-header">
          <div className="header-left">
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <FiPackage size={32} color="#495057" />
              <div>
                <h1>Quản Lý Sản Phẩm Cửa Hàng</h1>
                <p>Quản lý sản phẩm và giá bán cho các cửa hàng</p>
              </div>
            </div>
          </div>
          <div className="header-right">
            {availableCategoryTypes.length > 0 && (
              <ToggleButtonGroup
                value={categoryType}
                exclusive
                onChange={handleCategoryTypeChange}
                aria-label="category type"
                size="small"
                style={{ marginRight: "16px" }}
              >
                {availableCategoryTypes.map((type) => (
                  <ToggleButton key={type} value={type} aria-label={type}>
                    {CATEGORY_TYPE_LABELS[type]}
                  </ToggleButton>
                ))}
              </ToggleButtonGroup>
            )}
            <Button
              variant="contained"
              color="primary"
              startIcon={<Add />}
              onClick={() => handleOpenDialog()}
              className="btn btn-primary"
            >
              Thêm Sản Phẩm
            </Button>
          </div>
        </header>

        {alert.show && (
          <div className="content-section">
            <Alert severity={alert.type} className="mb-3">
              {alert.message}
            </Alert>
          </div>
        )}

        {/* Search and Filter Section */}
        <div className="content-section">
          <div className="card">
            <div className="card-header">
              <Typography variant="h6" className="mb-0">
                <Search style={{ marginRight: "8px", verticalAlign: "middle" }} />
                Tìm Kiếm & Lọc Dữ Liệu
                <Chip
                  label={categoryType === "bonPas" ? "BonPas" : "Đồng Tiến"}
                  size="small"
                  color="primary"
                  style={{ marginLeft: "10px" }}
                />
              </Typography>
            </div>
            <div className="card-body">
              <Grid container spacing={2} alignItems="center">
                <Grid span={{ xs: 12, md: 3 }}>
                  <TextField
                    fullWidth
                    label="Tìm kiếm theo mã sản phẩm"
                    placeholder="Nhập mã sản phẩm..."
                    value={searchFilters.searchText}
                    onChange={(e) =>
                      handleSearchChange("searchText", e.target.value)
                    }
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Search />
                        </InputAdornment>
                      ),
                    }}
                    size="small"
                  />
                </Grid>
                <Grid span={{ xs: 12, md: 4 }}>
                  <FormControl fullWidth size="small">
                    <InputLabel id="store-label"></InputLabel>
                    <Select
                      labelId="store-label"
                      value={searchFilters.selectedStore}
                      onChange={(e) =>
                        handleSearchChange("selectedStore", e.target.value)
                      }
                      label="Lọc theo cửa hàng"
                      displayEmpty
                      renderValue={(selected) =>
                        selected
                          ? filteredStores.find((s) => s.IDCH === selected)?.TenCuaHang
                          : "Tất cả cửa hàng"
                      }
                    >
                      <MenuItem value="">Tất cả cửa hàng</MenuItem>
                      {filteredStores.map((store) => (
                        <MenuItem key={store.IDCH} value={store.IDCH}>
                          {store.TenCuaHang}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid span={{ xs: 12, md: 3 }}>
                  <FormControl fullWidth size="small">
                    <InputLabel id="category-label"></InputLabel>
                    <Select
                      labelId="category-label"
                      value={searchFilters.selectedCategory}
                      onChange={(e) =>
                        handleSearchChange("selectedCategory", e.target.value)
                      }
                      label="Lọc theo loại sản phẩm"
                      displayEmpty
                      renderValue={(selected) =>
                        selected
                          ? categories.find((c) => c.MaNLSP === selected)?.TenLoaiSP
                          : "Tất cả loại sản phẩm"
                      }
                    >
                      <MenuItem value="">Tất cả loại sản phẩm</MenuItem>
                      {categories.map((category) => (
                        <MenuItem key={category.MaNLSP} value={category.MaNLSP}>
                          {category.TenLoaiSP}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid span={{ xs: 12, md: 2 }}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={searchFilters.showOnlyActive}
                        onChange={(e) =>
                          handleSearchChange("showOnlyActive", e.target.checked)
                        }
                        color="primary"
                      />
                    }
                    label="Chỉ hiển thị còn hạn"
                    style={{ marginTop: "8px" }}
                  />
                </Grid>
              </Grid>

              <Box
                mt={2}
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Typography variant="body2" color="text.secondary">
                  Hiển thị <strong>{filteredProducts.length}</strong> /{" "}
                  <strong>{products.length}</strong> sản phẩm
                </Typography>
                {(searchFilters.searchText ||
                  searchFilters.selectedStore ||
                  searchFilters.selectedCategory ||
                  searchFilters.showOnlyActive) && (
                  <Box display="flex" gap={1} flexWrap="wrap">
                    {searchFilters.searchText && (
                      <Chip
                        label={`Mã SP: ${searchFilters.searchText}`}
                        size="small"
                        onDelete={() => handleSearchChange("searchText", "")}
                        color="primary"
                        variant="outlined"
                      />
                    )}
                    {searchFilters.selectedStore && (
                      <Chip
                        label={`CH: ${getStoreName(searchFilters.selectedStore)}`}
                        size="small"
                        onDelete={() => handleSearchChange("selectedStore", "")}
                        color="info"
                        variant="outlined"
                      />
                    )}
                    {searchFilters.selectedCategory && (
                      <Chip
                        label={`Loại: ${getCategoryName(
                          searchFilters.selectedCategory
                        )}`}
                        size="small"
                        onDelete={() => handleSearchChange("selectedCategory", "")}
                        color="success"
                        variant="outlined"
                      />
                    )}
                    {searchFilters.showOnlyActive && (
                      <Chip
                        label="Chỉ còn hạn"
                        size="small"
                        onDelete={() => handleSearchChange("showOnlyActive", false)}
                        color="warning"
                        variant="outlined"
                      />
                    )}
                  </Box>
                )}
              </Box>
            </div>
          </div>
        </div>

        <div className="content-section">
          <div className="card">
            <div className="card-body">
              <TableContainer>
                <Table className="table table-striped">
                  <TableHead>
                    <TableRow className="bg-light">
                      <TableCell>
                        <strong>Cửa Hàng</strong>
                      </TableCell>
                      <TableCell>
                        <strong>Sản Phẩm</strong>
                      </TableCell>
                      <TableCell>
                        <strong>Loại Sản Phẩm</strong>
                      </TableCell>
                      <TableCell>
                        <strong>Giá Thường</strong>
                      </TableCell>
                      <TableCell>
                        <strong>Giá Grab</strong>
                      </TableCell>
                      <TableCell>
                        <strong>Giá Foody</strong>
                      </TableCell>
                      <TableCell>
                        <strong>Từ Ngày</strong>
                      </TableCell>
                      <TableCell>
                        <strong>Đến Ngày</strong>
                      </TableCell>
                      <TableCell>
                        <strong>Ưu Tiên</strong>
                      </TableCell>
                      <TableCell>
                        <strong>Thao Tác</strong>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {filteredProducts.length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={10} align="center">
                          <Box py={3}>
                            <Typography variant="body1" color="text.secondary">
                              {products.length === 0
                                ? "Chưa có dữ liệu sản phẩm"
                                : "Không tìm thấy sản phẩm nào phù hợp với bộ lọc"}
                            </Typography>
                          </Box>
                        </TableCell>
                      </TableRow>
                    ) : (
                      filteredProducts.map((product, index) => (
                        <TableRow key={index} hover>
                          <TableCell>
                            <Chip
                              label={getStoreName(product.IDCH)}
                              color="info"
                              variant="outlined"
                              size="small"
                            />
                          </TableCell>
                          <TableCell>
                            <Chip
                              label={product.MaSP}
                              color="primary"
                              variant="outlined"
                            />
                          </TableCell>
                          <TableCell>{getCategoryName(product.MaNLSP)}</TableCell>
                          <TableCell className="text-success fw-bold">
                            {formatCurrency(product.Gia)}
                          </TableCell>
                          <TableCell className="text-warning fw-bold">
                            {formatCurrency(product.GiaGrab || 0)}
                          </TableCell>
                          <TableCell className="text-info fw-bold">
                            {formatCurrency(product.GiaFoody || 0)}
                          </TableCell>
                          <TableCell>{formatDate(product.TuNgay)}</TableCell>
                          <TableCell>{formatDate(product.DenNgay)}</TableCell>
                          <TableCell>
                            <Chip
                              label={`Mức ${product.UuTien}`}
                              color={
                                product.UuTien === 1
                                  ? "success"
                                  : product.UuTien === 2
                                  ? "warning"
                                  : "default"
                              }
                              size="small"
                            />
                          </TableCell>
                          <TableCell>
                            <Box display="flex" gap={1}>
                              <Button
                                size="small"
                                variant="outlined"
                                color="primary"
                                startIcon={<Edit />}
                                onClick={() => handleOpenDialog(product)}
                              >
                                Sửa
                              </Button>
                              <Button
                                size="small"
                                variant="outlined"
                                color="error"
                                startIcon={<Delete />}
                                onClick={() => handleDelete(product)}
                              >
                                Xóa
                              </Button>
                            </Box>
                          </TableCell>
                        </TableRow>
                      ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </div>
        </div>

        {/* Dialog Form */}
        <Dialog
          open={openDialog}
          onClose={handleCloseDialog}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <span>
                {editingProduct ? "Chỉnh Sửa Sản Phẩm" : "Thêm Sản Phẩm Mới"}
              </span>
              {!editingProduct && availableCategoryTypes.length > 1 && (
                <ToggleButtonGroup
                  value={categoryType}
                  exclusive
                  onChange={handleCategoryTypeChange}
                  aria-label="category type"
                  size="small"
                >
                  {availableCategoryTypes.map((type) => (
                    <ToggleButton key={type} value={type} aria-label={type}>
                      {CATEGORY_TYPE_LABELS[type]}
                    </ToggleButton>
                  ))}
                </ToggleButtonGroup>
              )}
            </Box>
          </DialogTitle>
          <DialogContent>
            <Box display="flex" flexDirection="column" gap={2} mt={1}>
              {!editingProduct && (
                <FormControlLabel
                  control={<Switch checked={isBulkMode} onChange={handleBulkModeChange} />}
                  label="Thêm hàng loạt"
                />
              )}
              {editingProduct ? (
                // Single store selection for editing
                <FormControl fullWidth required>
                  <InputLabel>Cửa Hàng</InputLabel>
                  <Select
                    name="IDCH"
                    value={formData.IDCH}
                    onChange={handleInputChange}
                    label="Cửa Hàng"
                  >
                    {filteredStores.map((store) => (
                      <MenuItem key={store.IDCH} value={store.IDCH}>
                        {store.TenCuaHang}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              ) : (
                // Multiple store selection for adding new
                <FormControl fullWidth required>
                  <InputLabel>Cửa Hàng (Có thể chọn nhiều)</InputLabel>
                  <Select
                    multiple
                    name="IDCHs"
                    value={formData.IDCHs}
                    onChange={handleStoreChange}
                    label="Cửa Hàng (Có thể chọn nhiều)"
                    renderValue={(selected) => (
                      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                        {selected.map((value) => {
                          const store = filteredStores.find(
                            (s) => s.IDCH.toString() === value.toString()
                          );
                          return (
                            <Chip
                              key={value}
                              label={store ? store.TenCuaHang : value}
                              size="small"
                              color="primary"
                              variant="outlined"
                            />
                          );
                        })}
                      </Box>
                    )}
                  >
                    {filteredStores.map((store) => (
                      <MenuItem key={store.IDCH} value={store.IDCH}>
                        {store.TenCuaHang}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              )}

              {isBulkMode && !editingProduct ? (
                <>
                  <FormControl fullWidth required>
                    <InputLabel>Loại Sản Phẩm (Có thể chọn nhiều)</InputLabel>
                    <Select
                      multiple
                      name="selectedCategories"
                      value={formData.selectedCategories}
                      onChange={(e) => setFormData((prev) => ({ ...prev, selectedCategories: e.target.value }))}
                      label="Loại Sản Phẩm (Có thể chọn nhiều)"
                      renderValue={(selected) => (
                        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                          {selected.map((value) => {
                            const category = categories.find((c) => c.MaNLSP === value);
                            return (
                              <Chip
                                key={value}
                                label={category ? category.TenLoaiSP : value}
                                size="small"
                                color="secondary"
                                variant="outlined"
                              />
                            );
                          })}
                        </Box>
                      )}
                    >
                      <MenuItem onClick={handleSelectAllCategories}>
                        <strong>{formData.selectedCategories.length === categories.length ? "Bỏ chọn tất cả" : "Chọn tất cả"}</strong>
                      </MenuItem>
                      {categories.map((category) => (
                        <MenuItem key={category.MaNLSP} value={category.MaNLSP}>
                          {category.TenLoaiSP}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <FormControl component="fieldset">
                    <FormLabel component="legend">Điều chỉnh giá</FormLabel>
                    <RadioGroup
                      row
                      value={formData.adjustmentType}
                      onChange={(e) => setFormData((prev) => ({ ...prev, adjustmentType: e.target.value }))}
                    >
                      <FormControlLabel value="increase" control={<Radio />} label="Tăng" />
                      <FormControlLabel value="decrease" control={<Radio />} label="Giảm" />
                    </RadioGroup>
                  </FormControl>
                  <FormControl component="fieldset">
                    <RadioGroup
                      row
                      value={formData.adjustmentUnit}
                      onChange={(e) => setFormData((prev) => ({ ...prev, adjustmentUnit: e.target.value }))}
                    >
                      <FormControlLabel value="%" control={<Radio />} label="%" />
                      <FormControlLabel value="VND" control={<Radio />} label="VND" />
                    </RadioGroup>
                  </FormControl>
                  <TextField
                    label="Giá trị"
                    type="number"
                    value={formData.adjustmentValue}
                    onChange={(e) => setFormData((prev) => ({ ...prev, adjustmentValue: e.target.value }))}
                    InputProps={{
                      endAdornment: <InputAdornment position="end">{formData.adjustmentUnit}</InputAdornment>,
                    }}
                  />
                </>
              ) : (
                <>
                  <FormControl fullWidth required>
                    <InputLabel>
                      Loại Sản Phẩm ({CATEGORY_TYPE_LABELS[categoryType]})
                    </InputLabel>
                    <Select
                      name="MaNLSP"
                      value={formData.MaNLSP}
                      onChange={handleInputChange}
                      label={`Loại Sản Phẩm (${CATEGORY_TYPE_LABELS[categoryType]})`}
                    >
                      {categories.map((category) => (
                        <MenuItem key={category.MaNLSP} value={category.MaNLSP}>
                          {category.TenLoaiSP}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  <Autocomplete
                    options={items}
                    getOptionLabel={(option) => `${option.MaSP} - ${option.Ten_SP}`}
                    value={
                      items.find((item) => item.MaSP === formData.MaSP) || null
                    }
                    onChange={handleProductSelect}
                    renderInput={(params) => (
                      <TextField {...params} label="Sản Phẩm" required fullWidth />
                    )}
                    disabled={!formData.MaNLSP}
                  />

                  <Grid container spacing={2}>
                    <Grid span={{ xs: 12, md: 4 }}>
                      <TextField
                        name="Gia"
                        label="Giá Thường"
                        type="number"
                        value={formData.Gia}
                        onChange={handleInputChange}
                        fullWidth
                        required
                        InputProps={{
                          endAdornment: <InputAdornment position="end">₫</InputAdornment>,
                        }}
                      />
                    </Grid>
                    <Grid span={{ xs: 12, md: 4 }}>
                      <TextField
                        name="GiaGrab"
                        label="Giá Grab"
                        type="number"
                        value={formData.GiaGrab}
                        onChange={handleInputChange}
                        fullWidth
                        InputProps={{
                          endAdornment: <InputAdornment position="end">₫</InputAdornment>,
                        }}
                      />
                    </Grid>
                    <Grid span={{ xs: 12, md: 4 }}>
                      <TextField
                        name="GiaFoody"
                        label="Giá Foody"
                        type="number"
                        value={formData.GiaFoody}
                        onChange={handleInputChange}
                        fullWidth
                        InputProps={{
                          endAdornment: <InputAdornment position="end">₫</InputAdornment>,
                        }}
                      />
                    </Grid>
                  </Grid>
                </>
              )}

              <TextField
                name="TuNgay"
                label="Từ Ngày"
                type="date"
                value={formData.TuNgay}
                onChange={handleInputChange}
                fullWidth
                InputLabelProps={{ shrink: true }}
                required
              />
              <TextField
                name="DenNgay"
                label="Đến Ngày"
                type="date"
                value={formData.DenNgay}
                onChange={handleInputChange}
                fullWidth
                InputLabelProps={{ shrink: true }}
                required
              />
              <FormControl fullWidth>
                <InputLabel>Mức Ưu Tiên</InputLabel>
                <Select
                  name="UuTien"
                  value={formData.UuTien}
                  onChange={handleInputChange}
                  label="Mức Ưu Tiên"
                >
                  <MenuItem value={1}>Mức 1 - Cao nhất</MenuItem>
                  <MenuItem value={2}>Mức 2 - Trung bình</MenuItem>
                  <MenuItem value={3}>Mức 3 - Thấp</MenuItem>
                </Select>
              </FormControl>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDialog} color="secondary">
              Hủy
            </Button>
            <Button onClick={handleSubmit} color="primary" variant="contained">
              {editingProduct ? "Cập Nhật" : isBulkMode ? "Thêm Hàng Loạt" : "Thêm Mới"}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </div>
  );
};

export default QuanLySanPham;
